import { useState } from 'react'
import { Trans } from 'react-i18next'

import quotes from '~/assets/images/sprite/quotes.svg'
import { Styles as S } from '~/pages/history/binaryChoice/sharedStyles'
import { Styles as SingleS } from '~/pages/onboarding/quizSingleChoice/libs/styles'
import { SvgImage } from '~/shared/components/SvgImage'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'Do you agree with this statement?'

const RATING_OPTIONS = [1, 2, 3, 4, 5] as const

const StayingMotivated = ({ nextPagePath, pageId }: TPageProps) => {
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <div>
          <S.Question>
            <Trans
              ns="history"
              i18nKey="onboarding.historyStayingMotivated.title"
            />
          </S.Question>

          <SingleS.StatementContainer>
            <SvgImage svg={quotes} width={16} />
            <SingleS.Statement>
              <Trans
                ns="history"
                i18nKey="onboarding.historyStayingMotivated.statement"
              />
            </SingleS.Statement>
          </SingleS.StatementContainer>
        </div>

        <S.RatingWrapper>
          <S.RatingButtons>
            {RATING_OPTIONS.map((value) => (
              <S.RatingButton
                key={value}
                type="button"
                $isSelected={answer === String(value)}
                disabled={isAnswersDisabled}
                onClick={() => {
                  const val = String(value)
                  setAnswer(val)
                  setIsAnswersDisabled(true)
                  handleChange(val, handleContinue)
                }}
              >
                {value}
              </S.RatingButton>
            ))}
          </S.RatingButtons>

          <S.RatingLabels>
            <S.RatingLabel>
              <Trans
                ns="history"
                i18nKey="onboarding.historyStayingMotivated.labelLeft"
              />
            </S.RatingLabel>
            <S.RatingLabel>
              <Trans
                ns="history"
                i18nKey="onboarding.historyStayingMotivated.labelRight"
              />
            </S.RatingLabel>
          </S.RatingLabels>
        </S.RatingWrapper>
      </S.StyledContainer>
    </S.Root>
  )
}

export default StayingMotivated
